import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field, FieldArray } from 'formik'
import axios from 'axios'
import moment from 'moment'
import useOnclickOutside from "react-cool-onclickoutside"
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../../services/redirect'
import Spinner from '../../../services/spinner'
import AlertMessage from '../../../services/alert'

import { DropdownComponent } from '../../../components/options'
import { ValidateForm } from '../../../validations/schemaRole'


export default function AddComponent(props){

  /*----------------------------------------
    HANDLE CLICK OUTSIDE ELEMENT
  -----------------------------------------*/

  const handleClickAway = useOnclickOutside(() => CallbackModal({close:true}));
  function CallbackModal(data){
    if(spinner){
      return false;
    }
    props.callback(data);
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }


  /*----------------------------------------
    FORM STATE DATA
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  const [pathUrl, setPathUrl] = useState('');

  const [avatarDefault, setPathUrlDefault] = useState('');
  const [avatarBlank, setPathUrlBlank] = useState('');

  const [state, setstate] = useState({
    name:'',
    description:'',
    list:props.data.list
  });


  function handleSubmitForm(values, props){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','add');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/users-management/users-role/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj=='success'){
        props.resetForm();
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},2000);
        if(buttonclick==1){
          setTimeout(function() {CallbackModal({close:true,reload:true});},2000);
        }else{
          setTimeout(function() {
            setTimeout(function() {setnotify(false);},2000);
            CallbackModal({reload:true});
          },2000);
        }
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

    })
    .catch(function (error){
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }



  return (
    <React.Fragment>

    <Formik
        initialValues={state}
        validationSchema={ValidateForm}
        onSubmit={handleSubmitForm}
        render={formProps => {
        const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps

        return(
           <Form>
            <div className="modalpanel-wrapper">
              <div className="modalpanel-container small center animate__animated animate__slideInUp animate__faster" ref={handleClickAway}>

              {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
              {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}


              {/*---------------------------------------------------------
                 HEADER
                --------------------------------------------------------*/}
                 <div className="modalpanel-header">
                    <div><h2>Add Role</h2></div>
                    <div onClick={()=>CallbackModal({close:true})}><i className="uil-multiply"></i></div>
                 </div>


                 {/*---------------------------------------------------------
                    BODY
                   --------------------------------------------------------*/}

                 <div className="modalpanel-body">
                    <div className="modalpanel-content">

                        <Form.Group widths="equal">
                            <Field name="name">
                                {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Name</label>
                                  <Input {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Field name="description">
                                {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Description</label>
                                  <TextArea {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>

                        <div class="alert-message info left" style={{'margin':'5px 0 15px 0'}}>
                            <div><i class="info circle icon"></i></div>
                            <div>
                              <h4>Manage Permission</h4>
                              <p>You can select the approriate actions for the user. Please select action according their role in the system.</p>
                             </div>
                        </div>

                        <FieldArray
                           name="list"
                           render={arrayHelpers => (
                             <div>
                               {values.list.map((data, key) => (
                                    <React.Fragment  key={key}>
                                       <div className="permission-wrapper">
                                           <div><label>{data.name}</label></div>
                                           <div>
                                              <Form.Group inline widths='equal'>

                                                <Field>
                                                   {({ field, form }) => (
                                                   <Form.Field >
                                                     <Checkbox
                                                        name={`list[${key}].view`}
                                                        id={`__id[${key}].view`}
                                                        onChange={(e) => {

                                                          if(e.target.checked){
                                                            setFieldValue(`list[${key}].view`, 1);
                                                          }else{
                                                            setFieldValue(`list[${key}].view`, 0);
                                                            setFieldValue(`list[${key}].adding`, 0);
                                                            setFieldValue(`list[${key}].editing`, 0);
                                                            setFieldValue(`list[${key}].deleting`, 0);
                                                          }

                                                        }}
                                                        defaultChecked={data.view==1}
                                                        label='View' />
                                                   </Form.Field>
                                                   )}
                                                </Field>

                                                <Field>
                                                   {({ field, form }) => (
                                                   <Form.Field >
                                                     <Checkbox
                                                        name={`list[${key}].adding`}
                                                        id={`__id[${key}].adding`}
                                                        onChange={(e) => {

                                                          if(e.target.checked){
                                                            setFieldValue(`list[${key}].adding`, 1);
                                                          }else{
                                                            setFieldValue(`list[${key}].adding`, 0);
                                                          }

                                                        }}
                                                        checked={values.list[key].adding==1&&values.list[key].view==1}
                                                        disabled={values.list[key].view==0}
                                                        label='Add' />
                                                   </Form.Field>
                                                   )}
                                                </Field>

                                                <Field>
                                                   {({ field, form }) => (
                                                   <Form.Field >
                                                     <Checkbox
                                                        name={`list[${key}].editing`}
                                                        id={`__id[${key}].editing`}
                                                        onChange={(e) => {

                                                          if(e.target.checked){
                                                            setFieldValue(`list[${key}].editing`, 1);
                                                          }else{
                                                            setFieldValue(`list[${key}].editing`, 0);
                                                          }

                                                        }}
                                                        checked={values.list[key].editing==1&&values.list[key].view==1}
                                                        disabled={values.list[key].view==0}
                                                        label='Edit' />
                                                   </Form.Field>
                                                   )}
                                                </Field>


                                                <Field>
                                                   {({ field, form }) => (
                                                   <Form.Field >
                                                     <Checkbox
                                                        name={`list[${key}].deleting`}
                                                        id={`__id[${key}].deleting`}
                                                        onChange={(e) => {

                                                          if(e.target.checked){
                                                            setFieldValue(`list[${key}].deleting`, 1);
                                                          }else{
                                                            setFieldValue(`list[${key}].deleting`, 0);
                                                          }

                                                        }}
                                                        checked={values.list[key].deleting==1&&values.list[key].view==1}
                                                        disabled={values.list[key].view==0}
                                                        label='Delete' />
                                                   </Form.Field>
                                                   )}
                                                </Field>

                                               


                                             </Form.Group>
                                          </div>
                                        </div>

                                        </React.Fragment>
                                    ))}
                                    </div>
                              )}/>



                    </div>
                 </div>


                 {/*---------------------------------------------------------
                    FOOTER
                   --------------------------------------------------------*/}

                 <div className="modalpanel-footer">
                    <div className="modalpanel-footer-container">
                       <div><Button disabled={!(isValid&&dirty)} fluid className='BasicButton strong' content='Save and Exit' icon='save icon'  onClick={() => buttonSubmit(1)}/></div>
                       <div><Button disabled={!(isValid&&dirty)} fluid className='PrimaryButton strong' content='Save and Stay' icon='save icon'  onClick={() => buttonSubmit(2)}/></div>
                     </div>
                     <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                 </div>



              </div>{/*.modalpanel-container*/}
            </div>
          </Form>
        )}}/>
    </React.Fragment>
  )
}
